const VideoType = () => {
  return <>VideoType</>;
};
export default VideoType;

// import { PlusOutlined } from "@ant-design/icons";
// import {
//   ActionType,
//   FooterToolbar,
//   ModalForm,
//   PageContainer,
//   ParamsType,
//   ProColumns,
//   ProDescriptions,
//   ProDescriptionsItemProps,
//   ProFormDigit,
//   ProFormItem,
//   ProTable,
//   RequestData,
// } from "@ant-design/pro-components";
// import {
//   Button,
//   Drawer,
//   Popconfirm,
//   Select,
//   Space,
//   Tag,
//   Tooltip,
//   message,
//   Switch,
//   Modal,
//   Upload,
// } from "antd";
// import {
//   Ellipsis,
//   Image,
//   ImageViewer,
//   Loading,
//   SpinLoading,
//   Toast,
// } from "antd-mobile";
// import { useContext, useEffect, useMemo, useRef, useState } from "react";
// import VideoApi, { VideoDataType } from "services/apis/cnt/video-api";
// import styles from "./index.module.scss";
// import { DownlandOutline, UpOutline, UploadOutline } from "antd-mobile-icons";
// import VideoTypeApi, {
//   VideoTypeDataType,
// } from "services/apis/cnt/video-type-api";
// import { Check } from "services/requestCheck";
// import VideoAlbumApi, {
//   VideoAlbumDataType,
// } from "services/apis/cnt/video-album-api";
// import { DateFilter } from "services/CommonDT";
// import { arraySwap } from "@dnd-kit/sortable";
// import { CrumbContext } from "App2";
// import { BreadcrumbItemType } from "antd/es/breadcrumb/Breadcrumb";
// import CountDown from "ant-design-pro/lib/CountDown";
// import { VideoListType } from "app/constant";
// import { seconds2Duration } from "utils/durationUtil";
// import { current } from "@reduxjs/toolkit";
// import ActionForm from "./actionForm";
// import { CheckDelete, CheckUpdate } from "./checkApi";
// import {
//   inputVideo,
//   outputVideo,
//   templateVideo,
// } from "services/apis/excel/excel-api";
// import type { RcFile, UploadFile, UploadProps } from "antd/es/upload/interface";
// import { bzBaseUrl } from "services/request";
// import {
//   LoadingOutlined,
//   FileExcelOutlined,
//   FilePdfOutlined,
// } from "@ant-design/icons";
// import { Spin } from "antd";

// export default function VideoType() {
//   //面包屑导航
//   const crumb = useContext(CrumbContext);

//   //表格ref
//   const actionRef = useRef<ActionType>();

//   //复选框
//   const [selectedRowsState, setSelectedRows] = useState<VideoDataType[]>([]);
//   //选中行
//   const [currentRow, setCurrentRow] = useState<VideoDataType>();

//   const [isAdd, handleIsAdd] = useState<boolean>(false);
//   //表单弹窗2合1
//   const [formVisible, handleFormVisible] = useState(false);
//   // //新建数据弹窗
//   // const [addVisible, handleAddVisible] = useState(false);
//   // //分步更新弹窗
//   // const [updateVisible, handleUpdateVisible] = useState<boolean>(false);
//   //批量删除按钮
//   const [deleteDisabled, handleDisabled] = useState(true);
//   //详细数据Drawer
//   const [showDetail, setShowDetail] = useState<boolean>(false);
//   //导入数据弹窗
//   const [inputVisible, setInputVisible] = useState<boolean>(false);
//   const [fileList, setFileList] = useState<UploadFile[]>([]);

//   // const [editable, setEditable] = useState<boolean>(false);
//   // const [editingKey, setEditingKey] = useState("");
//   // const isEditing = (record: VideoDataType) => record.uuid === editingKey;

//   const [videoTypeMap, setVideoTypeMap] = useState<
//     Map<string, VideoTypeDataType>
//   >(new Map());
//   const [videoAlbumMap, setVideoAlbumMap] = useState<
//     Map<string, VideoAlbumDataType>
//   >(new Map());

//   //字段筛选用
//   const [videoTypeList, setVideoTypeList] = useState<VideoTypeDataType[]>([]);
//   const [videoAlbumList, setVideoAlbumList] = useState<VideoAlbumDataType[]>(
//     []
//   );
//   //选择枚举用
//   const videoTypeEnum = useMemo(() => {
//     var typeEnum = {};
//     videoTypeList?.forEach(
//       (item) =>
//         // @ts-ignore
//         (typeEnum[item.uuid] = item.typeName)
//     );
//     console.log("typeEnum", typeEnum);
//     return typeEnum;
//   }, [videoTypeList]);
//   const videoAlbumEnum = useMemo(() => {
//     var albumEnum = {};
//     videoAlbumList?.forEach(
//       (item) =>
//         // @ts-ignore
//         (albumEnum[item.uuid] = item.albumName)
//     );
//     return albumEnum;
//   }, [videoAlbumList]);

//   const columns: ProColumns<VideoDataType>[] = [
//     // typeName: string;
//     // typeDesc: string;
//     // typeVideoCount: number;
//     // coverUrl: string;
//     // fkCoverMediaUuid: string;
//     // fkUpperTypeUuid: string;
//     {
//       key: "uuid",
//       title: "视频uuid",
//       dataIndex: "uuid",
//       hideInTable: true,
//       copyable: true,
//     },
//     {
//       valueType: "textarea",
//       key: "videoName",
//       title: "视频名称",
//       dataIndex: "videoName",
//       align: "center",
//       copyable: true,
//       filters: [
//         { text: "标题", value: "标题" },
//         { text: "萝莉", value: "loli" },
//         { text: "少女", value: "girl" },
//       ],
//       filterMode: "tree",
//       filterSearch: true,
//       onFilter: (value, record) => record.videoName.includes(value as string),
//       render: (dom, entity) => {
//         return (
//           <p
//             style={{
//               textAlign: "left",
//               margin: 0,
//             }}
//             onClick={() => {
//               setCurrentRow(entity);
//               setShowDetail(true);
//             }}
//           >
//             {dom}
//           </p>
//         );
//       },
//     },
//     {
//       key: "coverUrl",
//       title: "封面url",
//       dataIndex: "coverUrl",
//       valueType: "image",
//       copyable: true,
//       align: "center",
//       width: 150,
//       render: (dom, entity) => {
//         return (
//           <div style={{ display: "flex", flexDirection: "column" }}>
//             <Image
//               alt={entity.videoName}
//               src={entity.videoUrl}
//               width={150}
//               fit="cover"
//               onClick={() => {
//                 const handler = ImageViewer.show({
//                   maxZoom: 1,
//                   image: entity.videoUrl,
//                 });
//                 setTimeout(() => {
//                   handler.close();
//                 }, 3000);
//               }}
//             />
//             {dom}
//           </div>
//         );
//       },
//     },
//     {
//       key: "videoUrl",
//       title: "视频url",
//       dataIndex: "videoUrl",
//       align: "center",
//       copyable: true,
//       hideInTable: true,
//       hideInForm: true,
//       fixed: "left",
//     },
//     {
//       valueType: "digit",
//       key: "videoDuration",
//       title: "时长",
//       dataIndex: "videoDuration",
//       align: "center",
//       hideInSearch: true,
//       render: (dom, entity) => {
//         return seconds2Duration(entity.videoDuration);
//       },
//     },
//     //筛选时长
//     {
//       valueType: "digitRange",
//       key: "_videoDuration",
//       title: "时长",
//       dataIndex: "_videoDuration",
//       hideInForm: true,
//       hideInDescriptions: true,
//       hideInSetting: true,
//       hideInTable: true,
//       search: {
//         transform: (value) => {
//           return {
//             videoDurationStart: value[0],
//             videoDurationEnd: value[1],
//           };
//         },
//       },
//     },
//     {
//       valueType: "digit",
//       key: "likeCount",
//       title: "点赞数",
//       dataIndex: "likeCount",
//       align: "center",
//       hideInSearch: true,
//       sorter: (a, b) => {
//         return a.likeCount - b.likeCount;
//       },
//       // //表格 行内数据 的样式
//       // render(dom, entity, index, action, schema) {
//       //   return <>{dom}</>;
//       // },
//       // //表格 行内数据 的文字样式(效果未知?)
//       // renderText(text, record, index, action) {
//       //   return <></>;
//       // },
//       // //editable时的 行内表单项, 搜索表单项 的样式
//       // renderFormItem(schema, config, form, action) {
//       //   return (
//       //     <ProFormDigit
//       //       width={"xs"}
//       //       name={"likeCount"}
//       //       initialValue={config.record?.likeCount}
//       //     />
//       //   );
//       // },
//     },
//     //TODO:如果过滤字段 同时在表格显示, 需要另外渲染过滤项 (过滤项和修改项的样式冲突)
//     //筛选点赞数
//     {
//       valueType: "digitRange",
//       key: "_likeCount",
//       title: "点赞数",
//       dataIndex: "_likeCount",
//       hideInForm: true,
//       hideInDescriptions: true,
//       hideInSetting: true,
//       hideInTable: true,
//       search: {
//         transform: (value) => {
//           return {
//             likeCountStart: value[0],
//             likeCountEnd: value[1],
//           };
//         },
//       },
//     },
//     {
//       valueType: "digit",
//       key: "hoardCount",
//       title: "收藏数",
//       dataIndex: "hoardCount",
//       align: "center",
//       hideInSearch: true,
//       sorter: (a, b) => {
//         return a.hoardCount - b.hoardCount;
//       },
//     },
//     //筛选收藏数
//     {
//       valueType: "digitRange",
//       key: "_hoardCount",
//       title: "收藏数",
//       dataIndex: "_hoardCount",
//       hideInForm: true,
//       hideInDescriptions: true,
//       hideInSetting: true,
//       hideInTable: true,
//       search: {
//         transform: (value) => {
//           return {
//             hoardCountStart: value[0],
//             hoardCountEnd: value[1],
//           };
//         },
//       },
//     },
//     {
//       valueType: "digit",
//       key: "commentCount",
//       title: "评论数",
//       dataIndex: "commentCount",
//       align: "center",
//       hideInSearch: true,
//       sorter: (a, b) => {
//         return a.commentCount - b.commentCount;
//       },
//     },
//     //筛选评论数
//     {
//       valueType: "digitRange",
//       key: "_commentCount",
//       title: "评论数",
//       dataIndex: "_commentCount",
//       hideInForm: true,
//       hideInDescriptions: true,
//       hideInSetting: true,
//       hideInTable: true,
//       search: {
//         transform: (value) => {
//           return {
//             commentCountStart: value[0],
//             commentCountEnd: value[1],
//           };
//         },
//       },
//     },
//     {
//       valueType: "digit",
//       key: "hotIndex",
//       title: "热门指数",
//       dataIndex: "hotIndex",
//       align: "center",
//       hideInSearch: true,
//       sorter: (a, b) => {
//         return a.hotIndex - b.hotIndex;
//       },
//     },
//     //筛选热门指数
//     {
//       valueType: "digitRange",
//       key: "_hotIndex",
//       title: "热门指数",
//       dataIndex: "_hotIndex",
//       hideInForm: true,
//       hideInDescriptions: true,
//       hideInSetting: true,
//       hideInTable: true,
//       search: {
//         transform: (value) => {
//           return {
//             hotIndexStart: value[0],
//             hotIndexEnd: value[1],
//           };
//         },
//       },
//     },
//     {
//       key: "fkVideoMediaUuid",
//       title: "视频uuid",
//       dataIndex: "fkVideoMediaUuid",
//       hideInTable: true,
//       copyable: true,
//     },
//     {
//       key: "fkCoverMediaUuid",
//       title: "封面uuid",
//       dataIndex: "fkCoverMediaUuid",
//       hideInTable: true,
//       copyable: true,
//     },
//     {
//       valueType: "select",
//       valueEnum: videoTypeEnum,
//       key: "fkVideoTypeUuid",
//       title: "分类",
//       dataIndex: "fkVideoTypeUuid",
//       align: "center",
//       render: (_, record) => (
//         <Space>
//           <Popconfirm
//             title="跳转分类"
//             onConfirm={() => {
//               //TODO:跳转分类
//             }}
//             disabled={record.fkVideoTypeUuid == null}
//           >
//             <Tag color={"blue"} key={record.fkVideoTypeUuid}>
//               {videoTypeMap?.get(record.fkVideoTypeUuid)?.typeName}
//             </Tag>
//           </Popconfirm>
//         </Space>
//       ),
//       filters: videoTypeList.map((item) => {
//         return { text: item.typeName + "", value: item.uuid + "" };
//       }),
//       filterMode: "tree",
//       filterSearch: true,
//       onFilter: (value, record) => record.fkVideoTypeUuid === value,
//     },
//     {
//       valueType: "select",
//       valueEnum: videoAlbumEnum,
//       key: "fkVideoAlbumUuid",
//       title: "专辑",
//       dataIndex: "fkVideoAlbumUuid",
//       align: "center",
//       render: (_, record) => (
//         <Space>
//           <Popconfirm
//             title="跳转专辑"
//             onConfirm={() => {
//               //TODO:跳转专辑
//             }}
//             disabled={record.fkVideoTypeUuid == null}
//           >
//             <Tag color={"cyan"} key={record.fkVideoAlbumUuid}>
//               {videoAlbumMap?.get(record.fkVideoAlbumUuid)?.albumName}
//             </Tag>
//           </Popconfirm>
//         </Space>
//       ),
//       filters: videoAlbumList.map((item) => {
//         return { text: item.albumName + "", value: item.uuid + "" };
//       }),
//       filterMode: "tree",
//       filterSearch: true,
//       onFilter: (value, record) => record.fkVideoAlbumUuid === value,
//     },
//     {
//       valueType: "digitRange",
//       key: "sortNumber",
//       title: "序号",
//       dataIndex: "sortNumber",
//       hideInTable: true,
//       search: {
//         transform: (value) => {
//           return {
//             sortNumberStart: value[0],
//             sortNumberEnd: value[1],
//           };
//         },
//       },
//     },
//     {
//       key: "status",
//       title: "状态",
//       initialValue: true,
//       dataIndex: "status",
//       filters: true,
//       onFilter: true,
//       valueType: "switch",
//       align: "center",
//       editable: false,
//       render(dom, entity, index, action, schema) {
//         return (
//           <Switch
//             checkedChildren="开启"
//             unCheckedChildren="关闭"
//             defaultChecked={entity.status === 1}
//             onChange={async (checked, event) => {
//               console.log(checked, event);
//               Check(
//                 await VideoApi.alterStatus(
//                   entity.uuid as string,
//                   checked ? 1 : 0
//                 ),
//                 () => {}
//               );
//             }}
//           />
//         );
//       },
//       // 渲染editable时显示
//       // renderFormItem(schema, config, form, action) {
//       //   return "111";
//       // },
//     },
//     {
//       key: "isDeleted",
//       title: "删除",
//       dataIndex: "isDeleted",
//       valueEnum: {
//         0: { text: "未删除", status: "Success" },
//         1: { text: "已删除", status: "Error" },
//       },
//       hideInTable: true,
//     },
//     {
//       key: "createUser",
//       title: "创建者",
//       dataIndex: "createUser",
//       hideInTable: true,
//     },
//     {
//       key: "updateUser",
//       title: "修改者",
//       dataIndex: "updateUser",
//       hideInTable: true,
//     },
//     {
//       key: "createTime",
//       title: "创建时间",
//       dataIndex: "createTime",
//       valueType: "dateRange",
//       hideInTable: true,
//       sorter: true,
//       search: {
//         transform: (value) => {
//           return {
//             createTimeBegin: value[0],
//             createTimeEnd: value[1],
//           };
//         },
//       },
//       render: (dom, entity) => {
//         return <span>{(entity.createTime + "").replace("T", " ")}</span>;
//       },
//     },
//     {
//       title: "修改时间",
//       dataIndex: "updateTime",
//       valueType: "dateRange",
//       hideInTable: true,
//       sorter: true,
//       search: {
//         transform: (value) => {
//           return {
//             updateTimeBegin: value[0],
//             updateTimeEnd: value[1],
//           };
//         },
//       },
//       render: (dom, entity) => {
//         return <span>{(entity.updateTime + "").replace("T", " ")}</span>;
//       },
//     },
//     {
//       title: "操作",
//       valueType: "option",
//       key: "option",
//       align: "center",
//       fixed: "right",
//       render: (text, entity, index, action) => {
//         // const editable = isEditing(record);
//         return [
//           // editable ? (
//           //   <span>
//           //     <Typography.Link
//           //       onClick={() => {
//           //         setEditingKey("");
//           //       }}
//           //       style={{ marginRight: 8 }}
//           //     >
//           //       Save
//           //     </Typography.Link>
//           //     <a
//           //       onClick={() => {
//           //         setEditingKey("");
//           //       }}
//           //     >
//           //       Cancel
//           //     </a>
//           //   </span>
//           // ) : (
//           //   <Typography.Link
//           //     disabled={editingKey !== ""}
//           //     onClick={() => setEditingKey(record.uuid + "")}
//           //   >
//           //     Edit
//           //   </Typography.Link>
//           // ),

//           <div
//             style={{
//               display: "flex",
//               flexDirection: "column",
//             }}
//           >
//             <Button
//               key="editable"
//               onClick={() => {
//                 //TODO:标签展示
//               }}
//               style={{ margin: 3 }}
//             >
//               标签
//             </Button>
//             <Button
//               key="editable"
//               onClick={() => {
//                 //TODO:评论展示
//               }}
//               style={{ margin: 3 }}
//             >
//               评论
//             </Button>
//           </div>,
//           <div style={{ display: "flex", flexDirection: "column" }}>
//             <Button
//               key="editable"
//               onClick={() => {
//                 action?.startEditable?.(entity.uuid + "");
//               }}
//               style={{ margin: 3 }}
//             >
//               编辑
//             </Button>
//             <Button
//               key="update"
//               onClick={() => {
//                 // message.info("修改" + record.uuid);
//                 setCurrentRow(entity);
//                 console.log("entity", entity);
//                 handleIsAdd(false);
//                 handleFormVisible(true);
//               }}
//               type="dashed"
//               style={{ margin: 3 }}
//             >
//               修改
//             </Button>
//             <Button key="delete" type="dashed" danger style={{ margin: 3 }}>
//               <Popconfirm
//                 title="确认删除?"
//                 onConfirm={() => handleDelete([entity.uuid + ""])}
//               >
//                 删除
//               </Popconfirm>
//             </Button>
//           </div>,
//         ];
//       },
//     },
//   ];

//   // const mergedColumns = columns.map((col) => {
//   //   // if (col.editable) {
//   //   //   return col;
//   //   // }
//   //   return {
//   //     ...col,
//   //     onCell: (record: VideoDataType) => ({
//   //       record,
//   //       inputType: true,
//   //       dataIndex: col.dataIndex,
//   //       title: col.title,
//   //       editing: isEditing(record),
//   //     }),
//   //   };
//   // });

//   useEffect(() => {
//     const fetch = async () => {
//       //请求视频分类
//       Check(await VideoTypeApi.list(), (result: any) => {
//         let map = new Map<string, VideoTypeDataType>();
//         (result as VideoTypeDataType[]).forEach((item) => {
//           map.set(item.uuid as string, item);
//         });
//         setVideoTypeMap(map);
//         setVideoTypeList(result);
//       });
//       //请求视频专辑
//       Check(await VideoAlbumApi.list(), (result: any) => {
//         let map = new Map<string, VideoAlbumDataType>();
//         (result as VideoAlbumDataType[]).forEach((item) => {
//           map.set(item.uuid as string, item);
//         });
//         setVideoAlbumMap(map);
//         setVideoAlbumList(result);
//       });
//     };
//     fetch();
//     let _crumbItems: BreadcrumbItemType[] = [
//       {
//         key: "a",
//         title: "首页",
//         href: "/console",
//       },
//       {
//         key: "b",
//         title: "内容管理",
//         href: "/console/cnt",
//       },
//       {
//         key: "c",
//         title: "视频类型",
//         href: "/console/cnt/video-type",
//       },
//     ];
//     crumb.setCrumbItems(
//       (crumbItems: BreadcrumbItemType[]) => (crumbItems = _crumbItems)
//     );
//   }, []);

//   const handleAdd = (data: VideoDataType[]) => {
//     message.info("handleAdd" + data);
//   };
//   const handleUpdate = (data: VideoDataType[]) => {
//     message.info("handleUpdate" + data);
//   };
//   const handleDelete = async (ids: string[]) => {
//     CheckDelete(ids, () => {
//       actionRef.current?.reload();
//     });
//   };

//   return (
//     <PageContainer>
//       <ProTable<VideoDataType>
//         style={{ margin: "-24px -40px" }}
//         // @ts-ignore
//         columns={columns}
//         actionRef={actionRef}
//         cardBordered
//         scroll={{ x: "max-content" }}
//         // @ts-ignore
//         request={async (
//           params: ParamsType & {
//             pageSize?: number;
//             current?: number;
//           }, //分页字段 + 当前行数据
//           sorter, // 表格字段的的sorter, 包含 descend/ascend
//           filter // 表格字段的的onFilter, 而非searchBar的搜索字段
//         ) => {
//           let dateFilter: DateFilter = {};
//           console.log("params:", params, "\nsort", sorter, "\nfilter", filter);
//           //TODO:WAIT 点赞数/收藏数/转发数/热门指数 的范围搜索
//           const {
//             pageSize,
//             current,
//             createTimeBegin,
//             createTimeEnd,
//             updateTimeBegin,
//             updateTimeEnd,
//             ...options
//           } = params;
//           //数据库status为0/1, switch的checked为true/false, 需要转换
//           if (options.status != null && options.status !== undefined) {
//             options.status = options.status ? 1 : 0;
//           }
//           const result = await VideoApi.page({
//             pageParams: {
//               pageSize: params?.pageSize as number,
//               current: params?.current as number,
//             },
//             // TODO:WAIT 分类/专辑 的字段过滤, 包括行内过滤和表单过滤, 默认当页数据过滤 (全表过滤需要配合后端)
//             filter: filter as unknown as VideoDataType,
//             dateFilter: {
//               createTimeBegin,
//               createTimeEnd,
//               updateTimeBegin,
//               updateTimeEnd,
//             },
//             sorter: {
//               sortColumn: Object.keys(sorter)[0],
//               sortType: sorter[Object.keys(sorter)[0]] + "",
//             },
//           });
//           if (result.code === 0 && result.successful) {
//             console.log("VideoApi.page", result.result);
//             return {
//               data: result.result.items,
//               page: result.result.page,
//               success: true,
//               total: result.result.counts,
//             } as Partial<RequestData<VideoDataType>>;
//           } else {
//             message.error("视频信息获取失败: " + result.msg);
//           }
//         }}
//         editable={{
//           type: "single",
//           onSave: async (key, record, originRow, newLineConfig) => {
//             CheckUpdate([record], () => {});
//           },
//           onDelete: async (key, row) => {
//             CheckDelete([key], () => {});
//           },
//           saveText: (
//             <span style={{ color: "#666", fontSize: 16, marginLeft: 30 }}>
//               保存
//             </span>
//           ),
//           deleteText: <span style={{ color: "#f66", fontSize: 16 }}>删除</span>,
//           cancelText: <span style={{ color: "#99f", fontSize: 16 }}>取消</span>,
//         }}
//         columnsState={{
//           persistenceKey: "uuid",
//           persistenceType: "localStorage",
//           onChange(value) {
//             console.log("value-------------: ", value);
//           },
//         }}
//         rowKey="uuid"
//         // search={{
//         //   labelWidth: "auto",
//         // }}
//         // options={{
//         //   setting: {
//         //     listsHeight: 400,
//         //   },
//         // }}
//         // form={{
//         //   // 由于配置了 transform，提交的参与与定义的不同这里需要转化一下
//         //   syncToUrl: (values, type) => {
//         //     if (type === "get") {
//         //       return {
//         //         ...values,
//         //         created_at: [values.startTime, values.endTime],
//         //       };
//         //     }
//         //     return values;
//         //   },
//         // }}
//         pagination={{
//           pageSize: 10,
//           onChange: (page) => console.log(page),
//         }}
//         dateFormatter="string"
//         headerTitle={<span style={{ letterSpacing: "nowrap" }}>查询数据</span>}
//         toolBarRender={(_, record) => [
//           <div
//             style={{
//               display: "flex",
//               flexDirection: "row",
//               flexWrap: "wrap",
//             }}
//           >
//             <div style={{ display: "flex", flexDirection: "row" }}>
//               <Button
//                 key="new"
//                 icon={<DownlandOutline />}
//                 onClick={() => {
//                   templateVideo();
//                 }}
//                 style={{ margin: 3 }}
//               >
//                 下载Excel示例
//               </Button>
//               <Button
//                 key="new"
//                 icon={<UploadOutline />}
//                 onClick={() => {
//                   setInputVisible(true);
//                 }}
//                 style={{ margin: 3 }}
//               >
//                 导入Excel数据
//               </Button>
//             </div>
//             <div style={{ display: "flex", flexDirection: "row" }}>
//               <Select
//                 key="out"
//                 defaultValue="导出数据"
//                 style={{ width: 150, margin: 3 }}
//                 onSelect={(value, option) => {
//                   if (value === "excel") outputVideo();
//                   if (value === "pdf") Toast.show("暂不支持");
//                 }}
//                 options={[
//                   {
//                     value: "excel",
//                     label: (
//                       <>
//                         <FileExcelOutlined style={{ marginRight: 5 }} />
//                         导出 Excel
//                       </>
//                     ),
//                   },
//                   {
//                     value: "pdf",
//                     label: (
//                       <>
//                         <FilePdfOutlined style={{ marginRight: 5 }} />
//                         导出 PDF
//                       </>
//                     ),
//                   },
//                 ]}
//               />
//               <Button
//                 key="new"
//                 icon={<PlusOutlined />}
//                 onClick={() => {
//                   handleIsAdd(true);
//                   handleFormVisible(true);
//                   actionRef.current?.reload();
//                 }}
//                 type="primary"
//                 style={{ margin: 3 }}
//               >
//                 新建数据
//               </Button>
//             </div>
//           </div>,
//         ]}
//         rowSelection={{
//           onChange: (_, selectedRows) => {
//             setSelectedRows(selectedRows);
//             console.log("selectedRows", selectedRows.length);
//             if (selectedRows.length === 0) {
//               handleDisabled(true);
//             }
//           },
//         }}
//       />
//       {selectedRowsState?.length > 0 && (
//         <FooterToolbar
//           style={{
//             width: 500,
//             borderRadius: 10,
//             margin: "0 20px 0 0",
//             backdropFilter: "blur(10px)",
//             WebkitBackdropFilter: "blur(10px)",
//           }}
//           extra={
//             <div>
//               已选择
//               <span
//                 style={{
//                   fontWeight: 600,
//                 }}
//               >
//                 {selectedRowsState.length}
//               </span>
//               项
//             </div>
//           }
//         >
//           <Popconfirm
//             title="确认删除"
//             disabled={deleteDisabled}
//             onConfirm={() => {
//               handleDelete(
//                 selectedRowsState.map((item) => item.uuid) as string[]
//               );
//               setSelectedRows([]);
//               actionRef.current?.reloadAndRest?.();
//             }}
//             onCancel={() => {
//               handleDisabled(true);
//             }}
//           >
//             <Button type="primary" danger disabled={deleteDisabled}>
//               <CountDown
//                 style={{ fontSize: 14 }}
//                 target={new Date().getTime() + 1000 * 5}
//                 format={(time) => {
//                   const seconds = Math.floor(time / 1000);
//                   if (seconds <= 0) return "批量删除";
//                   else return seconds + "批量删除";
//                 }}
//                 onEnd={() => {
//                   handleDisabled(false);
//                 }}
//               />
//             </Button>
//           </Popconfirm>
//         </FooterToolbar>
//       )}
//       <Drawer
//         width={400}
//         open={showDetail}
//         placement="right"
//         closable={true}
//         maskClosable={true}
//         onClose={() => {
//           setCurrentRow(undefined);
//           setShowDetail(false);
//         }}
//         title={<>视频信息</>}
//       >
//         {currentRow?.uuid && (
//           <ProDescriptions<VideoDataType>
//             column={1}
//             request={async () => ({
//               data: currentRow || {},
//             })}
//             params={{
//               id: currentRow?.uuid,
//             }}
//             columns={columns as ProDescriptionsItemProps<VideoDataType>[]}
//           />
//         )}
//       </Drawer>
//       <ActionForm
//         isAdd={isAdd}
//         formVisible={formVisible}
//         handleFormVisible={handleFormVisible}
//         data={{
//           currentRow: currentRow as VideoDataType,
//           videoTypeEnum,
//           videoAlbumEnum,
//         }}
//         callback={() => {
//           actionRef.current?.reload();
//         }}
//       />
//       <Modal
//         title="导入数据"
//         // centered={true}
//         open={inputVisible}
//         closable={true}
//         maskClosable={true}
//         footer={[
//           <Button
//             onClick={() => {
//               setInputVisible(false);
//               setFileList([]);
//             }}
//           >
//             取消
//           </Button>,
//           <Button
//             type="primary"
//             onClick={async () => {
//               console.log("onchange-info", fileList);
//               // const formData = new FormData(); 自动包装成表单对象
//               // formData.append("excelFile", fileList[0].originFileObj as RcFile);
//               // inputVideo(formData);
//               // 有效
//               Check(await inputVideo(fileList[0]), () => {
//                 Toast.show("文件读取成功");
//                 setInputVisible(false);
//                 actionRef.current?.reload();
//               });
//             }}
//           >
//             确认上传
//           </Button>,
//         ]}
//         onCancel={() => {
//           setInputVisible(false);
//           setFileList([]);
//         }}
//       >
//         <center style={{ margin: 20 }}>
//           <Upload
//             action={bzBaseUrl + "/excel/input/video"}
//             name="excelFile"
//             maxCount={1}
//             fileList={fileList}
//             beforeUpload={(file) => {
//               const fileTypeList = [
//                 "application/ms-excel",
//                 "application/msexcel",
//                 "application/vnd.ms-excel",
//                 "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//               ];
//               if (!fileTypeList.includes(file.type)) {
//                 message.error(`${file.name}不是Excel文件`);
//                 return false;
//               }
//               setFileList([file]);
//               return false;
//             }}
//             onRemove={(file) => {
//               const index = fileList.indexOf(file);
//               const newFileList = fileList.slice();
//               newFileList.splice(index, 1);
//               setFileList(newFileList);
//             }}
//             accept=".csv,.xls,.xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
//             onChange={(info) => {
//               console.log("onchange-info", info);
//               if (info.file.status !== "uploading") {
//               }
//               if (info.file.status === "done") {
//                 message.success(`${info.file.name} file uploaded successfully`);
//               } else if (info.file.status === "error") {
//                 message.error(`${info.file.name} file upload failed.`);
//               }
//             }}
//           >
//             <Button icon={<UploadOutline />} style={{ width: 120, height: 60 }}>
//               {fileList.length === 0 ? "点击上传" : "重新上传"}
//             </Button>
//           </Upload>
//         </center>
//       </Modal>
//       ;
//     </PageContainer>
//   );
// }
